import React from 'react'
import { useNavigate } from "react-router-dom";

import imageOne from '../../resource/meditate/external-retreat/2.png'
import imageFour from '../../resource/meditate/external-retreat/3.png'
import imageFive from '../../resource/meditate/external-retreat/4.png'
import imageThree from '../../resource/meditate/external-retreat/1.png'

import imageSix from '../../resource/meditate/external-retreat/5.png'
import TitleChnage from '../../Hook/TitleChnage'

import Calendar from '../Calendar/Calendar'
const ExternalRetreats = () => {
    TitleChnage("External Retreats")
const navigate = useNavigate();
    const handleClick = (event) => {
        const pathMap = {
          exRules:'/exRules',
          externalRetreatPackenham:'/externalRetreatPackenham',
          externalRetreatHallam:'/externalRetreatHallam',
          externalRetreatGlen:'/externalRetreatGlen'
        };
    
        const path = event.currentTarget.id;
        const targetPath = pathMap[path];
    
        if (targetPath) {
          navigate(targetPath);
        }
      };

  return (
    <div className="externalRetreat-page inside-pages">
    <div className="right-box">
        <img src={imageOne} alt="Right Top Image" className="right-image" width={300} />
    </div>

    <h1 className='font-main dark-gold p-4 mt-4'>External Retreats</h1>
    <h1 className='font-second dark-gold p-4 mt-4'>Conducted by Monastery Teachers</h1>

    <p className="mt-6 h4 p-4">External Retreats are led by the Sangha from the Bhaddeka Vihari Monastery but are held at external locations. These retreats are designed to reflect various aspects of the Buddha’s teachings, offering an opportunity for deeper spiritual exploration.</p>
    <p className="mt-5 h4 p-4">The programs typically include guided and silent meditation, walking meditation, and Dhamma discussions. They focus on both Tranquility (Samatha) and Insight (Vipassana) meditation, with retreat durations ranging from one to ten days. Participants also have the chance to ask questions and engage in individual or group discussions with the teacher, deepening their understanding of the teachings.</p>


    <h3 className="font-second  p-4 text-center mt-6">Retreats Schedule</h3>
    <h3 className="font-second  p-4 mt-6">Hallam</h3>

    <div className="p-4 calander-box  align-item-center">
    <div className="calnder text-center mt-5">                <Calendar/></div>
        <div className="details">
            <p className="font-p text-bold">Retreat Organizer - Hallam:</p>
            <p className="font-p">Mr.Indrajith  </p>
            <p className="font-p">045 0812 375</p>

            <p className="font-p mt-5">Hallam Community Centre, </p>
            <p className="font-p">56 Kaye Ave, Hallam</p>

            <p className="font-p mt-5">https://maps.app.goo.gl/BHhhZwczxobBdH1S6</p>
            <img src={imageSix} alt="Right Top Image" className='mt-5 curser-pointer' width={200} id='externalRetreatHallam' onClick={handleClick} />
        </div>
    </div>



<h3 className="font-second  p-4 mt-6">Glan Waverly</h3>

<div className="p-4 calander-box  align-item-center">
<div className="calnder text-center mt-5">                <Calendar/></div>
    <div className="details">
        <p className="font-p text-bold">Retreat Organizer - Glan Waverly: </p>
        <p className="font-p">Mr.Nilantha     </p>
        <p className="font-p">0487 389 693 </p>

        <p className="font-p mt-5">Glen Waverley International Hotel, Hermans Hall, </p>
        <p className="font-p">301 Springvale Road. </p>
        <p className="font-p">Glen Waverley.</p>

        <p className="font-p mt-5">https://maps.app.goo.gl/kQWZ9VECzP5yBEsUA</p>
        <img src={imageSix} alt="Right Top Image" className='mt-5 curser-pointer' width={200} id='externalRetreatGlen' onClick={handleClick} />


    </div>
</div>

<h3 className="font-second  p-4 mt-6">Pakenham</h3>

<div className="p-4 calander-box  align-item-center">
<div className="calnder text-center mt-5">                <Calendar/></div>
    <div className="details">
        <p className="font-p text-bold">Retreat Organizer - Pakenham </p>
        <p className="font-p">Mr.Kalum</p>
        <p className="font-p">0433 035 067</p>

        <p className="font-p mt-5">John Henry Primary School, Community Hub,</p>
        <p className="font-p">141 Henry Road, Pakenham. </p>

        <p className="font-p mt-5">https://maps.app.goo.gl/s2T3DGH4L7atp5Fy5</p>
        <img src={imageSix} alt="Right Top Image" className='mt-5 curser-pointer' width={200} id='externalRetreatPackenham' onClick={handleClick}  />


    </div>
</div>


    <div className='btn-group mt-6'>
        <img src={imageFour} alt="Right Top Image" width={300} id='exRules' onClick={handleClick} className='curser-pointer'/>
    </div>



        <div className="bottom-box mt-6">
        <img src={imageThree} alt="bottom-image"  width={600} />
    </div>

</div>
  )
}

export default ExternalRetreats